import { useEffect, useState } from 'react';

const Solo = () => {
  const [offer, setOffers] = useState([]);
  useEffect(() => {
    fetch('/data/offer.json')
      .then((res) => res.json())
      .then(setOffers)
      .catch(console.error);
  }, []);
  if (!offer) return <p>Ładowanie danych…</p>;
  console.log(offer);
  const trainig = offer?.data?.find((o) => o.name === 'SOLO');
  const singleTrainingPrice = trainig?.offers?.find(
    (o) => o.period === 1
  )?.price;
  return (
    <div class="max-w-3xl mx-auto space-y-6">
      <h1 class="text-4xl font-bold text-center mb-4 mt-4">
        Pakiety TRENINGI SOLO (1 osoba)
      </h1>
      <h3 class="text-1xl text-center mb-8 mt-4 text-gray-300">
        Indywidualny trening pod pełną opieką trenera, trwający około 60 minut.
        <br />
        Każda sesja jest dostosowana do Twoich celów, możliwości i aktualnej
        formy. <br />
        Niezależnie od tego, czy dopiero zaczynasz, czy chcesz wejść na wyższy
        poziom, trening 1:1 daje Ci maksymalną efektywność.
      </h3>
      <div class="grid grid-cols-1 gap-6">
        {trainig?.offers.map((i, index) => (
          <div
            key={index}
            class="bg-gray-800 p-8 rounded-3xl shadow-xl flex flex-col justify-between"
          >
            <div>
              <h2 class="text-2xl font-semibold mb-2">
                {i.special && '✅'} {i.name}
              </h2>
              <p class="text-lg font-bold">
                {i.price} zł
                {i.period > 1 && (
                  <span class="text-green-400 text-base">
                    {' '}
                    ({Math.round(i.price / i.period)} zł/trening — oszczędzasz
                    {i.special && ' aż'}
                    <b> {singleTrainingPrice * i.period - i.price} zł</b>)
                  </span>
                )}
              </p>
            </div>
          </div>
        ))}
        {/* <div class="bg-gray-800 p-6 rounded-2xl shadow-lg">
          <h2 class="text-2xl font-semibold mb-2">Trening pojedynczy</h2>
          <p class="text-lg font-bold">130 zł</p>
        </div>
        <div class="bg-gray-800 p-6 rounded-2xl shadow-lg">
          <h2 class="text-2xl font-semibold mb-2">Pakiet 4 treningów</h2>
          <p class="text-lg font-bold">
            450 zł{' '}
            <span class="text-green-400 text-base">
              (112,50 zł/trening — oszczędzasz 70 zł)
            </span>
          </p>
        </div>
        <div class="bg-gray-800 p-6 rounded-2xl shadow-lg">
          <h2 class="text-2xl font-semibold mb-2">Pakiet 8 treningów</h2>
          <p class="text-lg font-bold">
            800 zł{' '}
            <span class="text-green-400 text-base">
              (100 zł/trening — oszczędzasz 240 zł)
            </span>
          </p>
        </div>
        <div class="bg-gray-800 p-6 rounded-2xl shadow-lg">
          <h2 class="text-2xl font-semibold mb-2">Pakiet 12 treningów</h2>
          <p class="text-lg font-bold">
            1100 zł{' '}
            <span class="text-green-400 text-base">
              (91,70 zł/trening — oszczędzasz 460 zł)
            </span>
          </p>
        </div>
        <div class="bg-gray-800 p-6 rounded-2xl shadow-lg">
          <h2 class="text-2xl font-semibold mb-2">✅ Pakiet 16 treningów</h2>
          <p class="text-lg font-bold">
            1300 zł{' '}
            <span class="text-green-400 text-base">
              (81,25 zł/trening — oszczędzasz aż 780 zł!)
            </span>
          </p>
        </div> */}
      </div>
    </div>
  );
};

export default Solo;
